module.exports = __webpack_public_path__ + "static/media/AcuminPro.9eb201d7.svg";